import {Person} from "./session-context.model";
import {GeneralRequestResponse} from "./payloads/shared/save-request.model";

export interface DevicesDataResponse extends GeneralRequestResponse {
  mode: string;
  items: DevicesData[];
  acknowledgment: {
    acknowledgmentDetailList: any[];
    responseCode: string;
  };
}

export class DevicesData {
  readonly type: string = "device";
  updateTime: Date;
  defaultDevice: boolean;
  id: number;
  insertTime: Date;
  name: string;
  observationType: ObservationType;
  observationTypeId: number;
  person: Person;
  personId: number;
  representerPerson: Person;
  representerPersonId: number;
  serialNo: string;
  valueUnit: ValueUnit;
  valueUnitId: number;
}

export interface ObservationType {
  classificatorSystemId: number;
  code: string;
  id: number;
  insertTime: string;
  name: string;
  type: string;
}

export interface ValueUnit {
  classificatorSystemId: number;
  code: string;
  id: number;
  insertTime: string;
  name: string;
  type: string;
}
